import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import styled from 'styled-components';

import Button from '@material-ui/core/Button';
import DialogApp, { DialogAppTitle, DialogAppContent, DialogAppActions } from 'components/DialogApp';

import SyntaxHighlighter from 'react-syntax-highlighter';
import style from 'react-syntax-highlighter/styles/hljs/github';
import CopiedIcon from 'images/icon-copied.svg';

import tracker from 'scripts/tracker';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import InvitationButton from './InvitationButton';
import './JsDialog.css';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

let copiedContainer = null;

const showCopiedInfo = () => {
  if (!copiedContainer) return false;
  copiedContainer.classList.remove('is_active');
  copiedContainer.classList.add('is_active');

  setTimeout(() => {
    copiedContainer.classList.remove('is_active');
  }, 800);
};

const JsDialog = ({
  open,
  handleClose,
  user,
}) => {
  const id = get(user, 'id', 0);
  const script = tracker(id);
  if (!id) return null;

  return (
    <DialogApp
      open={open}
      onClose={handleClose}
      className="JsDialog"
    >
      <DialogAppTitle>
        Website
      </DialogAppTitle>

      <DialogAppContent>
        <div>
          {'Add this code as the first item in the <HEAD> of every webpage you want to track.'}
        </div>

        <div className="code">
          <SyntaxHighlighter
            language="javascript"
            style={style}
          >
            {script}
          </SyntaxHighlighter>

          <CopyToClipboard
            text={script}
            onCopy={showCopiedInfo}
          >
            <div className="copied" ref={ref => copiedContainer = ref}>
              <span>Copied!</span>
              <img src={CopiedIcon} alt="copied-icon" />
            </div>
          </CopyToClipboard>
        </div>

        <ButtonContainer>
          <InvitationButton script={script} user={user} />
        </ButtonContainer>
      </DialogAppContent>

      <DialogAppActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogAppActions>
    </DialogApp>
  );
};

JsDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

JsDialog.defaultProps = {
  open: false,
};

export default JsDialog;



// WEBPACK FOOTER //
// ./src/components/common/accounts/components/JsDialog/JsDialog.jsx